<!--
 * @Author: Tina Huang
 * @Date: 2024-01-11 10:13:56
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-11 14:27:37
 * @Description: 
-->
<template>
  <div class="lib-container">
    <iframe :src="link" frameborder="0" v-if="link"></iframe>
  </div>
</template>
<script>
export default {
  props: ["link"],
};
</script>
<style lang="less" scoped>
iframe {
  width: 100%;
  height: 30vh;
}
</style>